export default __webpack_public_path__ + "static/media/icon-home.37c23108.svg";